import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "events-calendar" }
const _hoisted_2 = { class: "events-header" }
const _hoisted_3 = { class: "page-eyebrow" }
const _hoisted_4 = { class: "events-title" }
const _hoisted_5 = { class: "events-intro" }
const _hoisted_6 = { class: "timeline" }
const _hoisted_7 = { class: "timeline-date" }
const _hoisted_8 = { class: "timeline-month" }
const _hoisted_9 = { class: "timeline-day" }
const _hoisted_10 = { class: "timeline-dot" }
const _hoisted_11 = {
  key: 0,
  class: "dot-pulse"
}
const _hoisted_12 = { class: "timeline-card glass-card" }
const _hoisted_13 = { class: "timeline-card-top" }
const _hoisted_14 = { class: "timeline-name" }
const _hoisted_15 = { class: "timeline-location" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.jsonData.eventsCalendarEyebrow), 1),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.jsonData.eventsCalendarTitle), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.jsonData.eventsCalendarIntro), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["timeline-item", { 'is-highlighted': event.status === 'next' || event.status === 'live', 'is-done': event.status === 'done' }]),
          key: event.name
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(event.month), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(event.day), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (event.status === 'next' || event.status === 'live')
              ? (_openBlock(), _createElementBlock("span", _hoisted_11))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(event.name), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["timeline-status", 'status-' + event.status])
              }, _toDisplayString(_ctx.statusLabel(event.status)), 3)
            ]),
            _createElementVNode("div", _hoisted_15, _toDisplayString(event.city), 1)
          ])
        ], 2))
      }), 128))
    ])
  ]))
}